import React, { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { Button } from "@mui/material";
import "./schedule.css";
import { MdModeEditOutline } from "react-icons/md";
import { Model } from "./../../components";
let Schedule = () => {
  let [activeScheduleTabs, setActiveSchuleTabs] = useState("Class");
  const [editSchedule, setEditSchedule] = useState(false);
  const [editModel, setEditModel] = useState(false);
  let TableData = [
    {
      time: "7:00 AM",
      dayMon: {
        subject: "Maths",
        teacherName: "Mr. Shetty",
      },
      dayTue: {
        subject: "Maths",
        teacherName: "Mr. Shetty",
      },
      dayWed: {
        subject: "Maths",
        teacherName: "Mr. Shetty",
      },
      dayThu: {
        subject: "Maths",
        teacherName: "Mr. Shetty",
      },
      dayFri: {
        subject: "Maths",
        teacherName: "Mr. Shetty",
      },
      breakTime: false,
    },
    {
      time: "7:45 AM",
      dayMon: {
        subject: "Bio",
        teacherName: "David",
      },
      dayTue: {
        subject: "Bio",
        teacherName: "David",
      },
      dayWed: {
        subject: "Bio",
        teacherName: "David",
      },
      dayThu: {
        subject: "Bio",
        teacherName: "David",
      },
      dayFri: {
        subject: "Bio",
        teacherName: "David",
      },
      breakTime: false,
    },
    {
      time: "8:30 AM",
      dayMon: {
        subject: "English",
        teacherName: "Smith",
      },
      dayTue: {
        subject: "English",
        teacherName: "Smith",
      },
      dayWed: {
        subject: "English",
        teacherName: "Smith",
      },
      dayThu: {
        subject: "English",
        teacherName: "Smith",
      },
      dayFri: {
        subject: "English",
        teacherName: "Smith",
      },
      breakTime: true,
    },
    {
      time: "10:00 AM",
      dayMon: {
        subject: "Science",
        teacherName: "Mr. Shetty",
      },
      dayTue: {
        subject: "Science",
        teacherName: "Mr. Shetty",
      },
      dayWed: {
        subject: "Science",
        teacherName: "Mr. Shetty",
      },
      dayThu: {
        subject: "Science",
        teacherName: "Mr. Shetty",
      },
      dayFri: {
        subject: "Science",
        teacherName: "Mr. Shetty",
      },
      breakTime: false,
    },
    {
      time: "10:45 AM",
      dayMon: {
        subject: "History",
        teacherName: "Smith",
      },
      dayTue: {
        subject: "History",
        teacherName: "Smith",
      },
      dayWed: {
        subject: "History",
        teacherName: "Smith",
      },
      dayThu: {
        subject: "History",
        teacherName: "Smith",
      },
      dayFri: {
        subject: "History",
        teacherName: "Smith",
      },
      breakTime: false,
    },
    {
      time: "11:30 AM",
      dayMon: {
        subject: "Maths",
        teacherName: "Mr. Shetty",
      },
      dayTue: {
        subject: "Maths",
        teacherName: "Mr. Shetty",
      },
      dayWed: {
        subject: "Maths",
        teacherName: "Mr. Shetty",
      },
      dayThu: {
        subject: "Maths",
        teacherName: "Mr. Shetty",
      },
      dayFri: {
        subject: "Maths",
        teacherName: "Mr. Shetty",
      },
      breakTime: false,
    },
  ];
  let TeachersTable = [
    {
      dayMon: {
        subject: "Maths",
        class: 4,
        div: "Div - A",
        time: "7:00 - 7:45 AM",
      },
      dayTue: {
        subject: "Maths",
        class: 4,
        div: "Div - A",
        time: "7:00 - 7:45 AM",
      },
      dayWed: {
        subject: "Maths",
        class: 4,
        div: "Div - A",
        time: "7:00 - 7:45 AM",
      },
      dayThu: {
        subject: "Maths",
        class: 4,
        div: "Div - A",
        time: "7:00 - 7:45 AM",
      },
      dayFri: {
        subject: "Maths",
        class: 4,
        div: "Div - A",
        time: "7:00 - 7:45 AM",
      },
      breakTime: false,
    },
    {
      dayMon: {
        subject: "Science ",
        class: 4,
        div: "Div - A",
        time: "7:00 - 7:45 AM",
      },
      dayTue: {
        subject: "Science ",
        class: 4,
        div: "Div - A",
        time: "7:00 - 7:45 AM",
      },
      dayWed: {
        subject: "Science ",
        class: 4,
        div: "Div - A",
        time: "7:00 - 7:45 AM",
      },
      dayThu: {
        subject: "Science ",
        class: 4,
        div: "Div - A",
        time: "7:00 - 7:45 AM",
      },
      dayFri: {
        subject: "Science ",
        class: 4,
        div: "Div - A",
        time: "7:00 - 7:45 AM",
      },
      breakTime: true,
    },
    {
      dayMon: {
        subject: "Maths ",
        class: 4,
        div: "Div - A",
        time: "7:00 - 7:45 AM",
      },
      dayTue: {
        subject: "Maths ",
        class: 4,
        div: "Div - A",
        time: "7:00 - 7:45 AM",
      },
      dayWed: {
        subject: "Maths ",
        class: 4,
        div: "Div - A",
        time: "7:00 - 7:45 AM",
      },
      dayThu: {
        subject: "Maths ",
        class: 4,
        div: "Div - A",
        time: "7:00 - 7:45 AM",
      },
      dayFri: {
        subject: "Maths ",
        class: 4,
        div: "Div - A",
        time: "7:00 - 7:45 AM",
      },
      breakTime: false,
    },
  ];
  return (
    <div>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xl={8} lg={8} md={8} sm={12} xs={12}></Grid>
          <Grid item xl={2} lg={2} md={2} sm={6} xs={6}>
            <Button
              className="header-button"
              variant="text"
              onClick={() => setEditSchedule(true)}
            >
              <p className="page-header-button-text">Edit Schedule</p>
            </Button>
          </Grid>
          <Grid item xl={2} lg={2} md={2} sm={6} xs={6}>
            <Button className="header-button" variant="text">
              <p className="page-header-button-text">Download PDF</p>
            </Button>
          </Grid>
          <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
            <Button
              className={
                activeScheduleTabs === "Class"
                  ? "schedule-active-tab-button"
                  : "schedule-tab-button"
              }
              variant="text"
              onClick={() => setActiveSchuleTabs("Class")}
            >
              <p
                className={
                  activeScheduleTabs === "Class"
                    ? "schedule-active-tab-button-text"
                    : "schedule-tab-button-text"
                }
              >
                Class
              </p>
            </Button>
          </Grid>
          <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
            <Button
              className={
                activeScheduleTabs === "Teachers"
                  ? "schedule-active-tab-button"
                  : "schedule-tab-button"
              }
              variant="text"
              onClick={() => setActiveSchuleTabs("Teachers")}
            >
              <p
                className={
                  activeScheduleTabs === "Teachers"
                    ? "schedule-active-tab-button-text"
                    : "schedule-tab-button-text"
                }
              >
                Teachers
              </p>
            </Button>
          </Grid>
        </Grid>
      </Box>
      <br />
      {activeScheduleTabs === "Class" && (
        <div>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                <div>
                  <p className="input-heading">Select Class</p>
                  <select className="input">
                    <option value="">Select</option>
                    <option value="Class 1A">Class 1A</option>
                    <option value="Class 2B">Class 2B</option>
                    <option value="Class 2C">Class 2C</option>
                    <option value="Class 2D">Class 2D</option>
                  </select>
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                <div>
                  <p className="input-heading">Select Division</p>
                  <select className="input">
                    <option value="">Select</option>
                    <option value="Division-A">Division-A</option>
                    <option value="Division-B">Division-B</option>
                    <option value="Division-C">Division-C</option>
                    <option value="Division-D">Division-D</option>
                  </select>
                </div>
              </Grid>
            </Grid>
          </Box>
          <h1 className="schedule-table-class-heading">Class 1A</h1>
          <div className="schedule-table-container">
            <table>
              <thead>
                <tr className="schedule-table-header">
                  <th className="schedule-table-sr-no-heading">No.</th>
                  <th className="schedule-table-time-heading">Time</th>
                  <th className="schedule-table-days-heading">Mon</th>
                  <th className="schedule-table-days-heading">Tue</th>
                  <th className="schedule-table-days-heading">Wed</th>
                  <th className="schedule-table-days-heading">Thu</th>
                  <th className="schedule-table-days-heading">Fri</th>
                </tr>
              </thead>
              {TableData.map((tableValue, tableIndex) => {
                return (
                  <tbody>
                    <tr className="schedule-calss-table-data-main">
                      <td className="schedule-table-sr-no-data">
                        {tableIndex + 1}
                      </td>
                      <td className="schedule-table-time-data">
                        {tableValue.time}
                      </td>
                      <td className="schedule-table-days-data">
                        <div className="time-table-edit-container">
                          <div className="time-table-edit-container-data">
                            <p className="schedule-table-days-data">
                              {tableValue.dayMon.subject}
                            </p>
                            <p className="schedule-table-days-data">
                              {tableValue.dayMon.teacherName}
                            </p>
                          </div>
                          {editSchedule && (
                            <Button
                              className="time-table-edit-button"
                              onClick={() => setEditModel(true)}
                            >
                              <MdModeEditOutline color="#000" size={"20px"} />
                            </Button>
                          )}
                        </div>
                      </td>
                      <td className="schedule-table-days-data">
                        <div className="time-table-edit-container">
                          <div className="time-table-edit-container-data">
                            <p className="schedule-table-days-data">
                              {tableValue.dayTue.subject}
                            </p>
                            <p className="schedule-table-days-data">
                              {tableValue.dayTue.teacherName}
                            </p>
                          </div>
                          {editSchedule && (
                            <Button
                              className="time-table-edit-button"
                              onClick={() => setEditModel(true)}
                            >
                              <MdModeEditOutline color="#000" size={"20px"} />
                            </Button>
                          )}
                        </div>
                      </td>
                      <td className="schedule-table-days-data">
                        <div className="time-table-edit-container">
                          <div className="time-table-edit-container-data">
                            <p className="schedule-table-days-data">
                              {tableValue.dayWed.subject}
                            </p>
                            <p className="schedule-table-days-data">
                              {tableValue.dayWed.teacherName}
                            </p>
                          </div>
                          {editSchedule && (
                            <Button
                              className="time-table-edit-button"
                              onClick={() => setEditModel(true)}
                            >
                              <MdModeEditOutline color="#000" size={"20px"} />
                            </Button>
                          )}
                        </div>
                      </td>
                      <td className="schedule-table-days-data">
                        <div className="time-table-edit-container">
                          <div className="time-table-edit-container-data">
                            <p className="schedule-table-days-data">
                              {tableValue.dayThu.subject}
                            </p>
                            <p className="schedule-table-days-data">
                              {tableValue.dayThu.teacherName}
                            </p>
                          </div>
                          {editSchedule && (
                            <Button
                              className="time-table-edit-button"
                              onClick={() => setEditModel(true)}
                            >
                              <MdModeEditOutline color="#000" size={"20px"} />
                            </Button>
                          )}
                        </div>
                      </td>
                      <td className="schedule-table-days-data">
                        <div className="time-table-edit-container">
                          <div className="time-table-edit-container-data">
                            <p className="schedule-table-days-data">
                              {tableValue.dayFri.subject}
                            </p>
                            <p className="schedule-table-days-data">
                              {tableValue.dayFri.teacherName}
                            </p>
                          </div>
                          {editSchedule && (
                            <Button
                              className="time-table-edit-button"
                              onClick={() => setEditModel(true)}
                            >
                              <MdModeEditOutline color="#000" size={"20px"} />
                            </Button>
                          )}
                        </div>
                      </td>
                    </tr>
                    {tableValue.breakTime && (
                      <tr>
                        <td
                          colSpan={7}
                          className="schedule-table-break-section"
                        >
                          <div className="schedule-table-break-section-data-main">
                            <div className="schedule-table-break-section-dotted" />
                            <p className="schedule-table-break-section-title">
                              Break 09:15 to 10:00
                            </p>
                            <div className="schedule-table-break-section-dotted" />
                          </div>
                        </td>
                      </tr>
                    )}
                  </tbody>
                );
              })}
            </table>
          </div>
        </div>
      )}
      {activeScheduleTabs === "Teachers" && (
        <div>
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Select Teacher</p>
                  <select className="input">
                    <option value="">Select</option>
                    <option value="Class 1A">Class 1A</option>
                    <option value="Class 2B">Class 2B</option>
                    <option value="Class 2C">Class 2C</option>
                    <option value="Class 2D">Class 2D</option>
                  </select>
                </div>
              </Grid>
              <Grid item xl={9} lg={9} md={9} sm={12} xs={12}>
                <div className="schedule-table-container">
                  <table>
                    <thead>
                      <tr className="schedule-table-header">
                        <th className="schedule-teacher-table-days-heading">
                          Mon
                        </th>
                        <th className="schedule-teacher-table-days-heading">
                          Tue
                        </th>
                        <th className="schedule-teacher-table-days-heading">
                          Wed
                        </th>
                        <th className="schedule-teacher-table-days-heading">
                          Thu
                        </th>
                        <th className="schedule-teacher-table-days-heading">
                          Fri
                        </th>
                      </tr>
                    </thead>
                    {TeachersTable.map(
                      (teacherTableValue, teacherTableIndex) => {
                        return (
                          <tbody key={teacherTableIndex}>
                            <tr className="schedule-teacher-table-days-data-main">
                              <td className="schedule-table-days-data">
                                <p className="schedule-table-days-data">
                                  {teacherTableValue.dayMon.subject}
                                </p>
                                <p className="schedule-table-days-data">
                                  Class {teacherTableValue.dayMon.class}
                                  <sup>th</sup>
                                </p>
                                <p className="schedule-table-days-data">
                                  {teacherTableValue.dayMon.div}
                                </p>
                                <p className="schedule-table-days-data">
                                  {teacherTableValue.dayMon.time}
                                </p>
                              </td>
                              <td className="schedule-table-days-data">
                                <p className="schedule-table-days-data">
                                  {teacherTableValue.dayTue.subject}
                                </p>
                                <p className="schedule-table-days-data">
                                  Class {teacherTableValue.dayTue.class}
                                  <sup>th</sup>
                                </p>
                                <p className="schedule-table-days-data">
                                  {teacherTableValue.dayTue.div}
                                </p>
                                <p className="schedule-table-days-data">
                                  {teacherTableValue.dayTue.time}
                                </p>
                              </td>
                              <td className="schedule-table-days-data">
                                <p className="schedule-table-days-data">
                                  {teacherTableValue.dayWed.subject}
                                </p>
                                <p className="schedule-table-days-data">
                                  Class {teacherTableValue.dayTue.class}
                                  <sup>th</sup>
                                </p>
                                <p className="schedule-table-days-data">
                                  {teacherTableValue.dayTue.div}
                                </p>
                                <p className="schedule-table-days-data">
                                  {teacherTableValue.dayTue.time}
                                </p>
                              </td>
                              <td className="schedule-table-days-data">
                                <p className="schedule-table-days-data">
                                  {teacherTableValue.dayThu.subject}
                                </p>
                                <p className="schedule-table-days-data">
                                  Class {teacherTableValue.dayWed.class}
                                  <sup>th</sup>
                                </p>
                                <p className="schedule-table-days-data">
                                  {teacherTableValue.dayWed.div}
                                </p>
                                <p className="schedule-table-days-data">
                                  {teacherTableValue.dayWed.time}
                                </p>
                              </td>
                              <td className="schedule-table-days-data">
                                <p className="schedule-table-days-data">
                                  {teacherTableValue.dayFri.subject}
                                </p>
                                <p className="schedule-table-days-data">
                                  Class {teacherTableValue.dayFri.class}
                                  <sup>th</sup>
                                </p>
                                <p className="schedule-table-days-data">
                                  {teacherTableValue.dayFri.div}
                                </p>
                                <p className="schedule-table-days-data">
                                  {teacherTableValue.dayFri.time}
                                </p>
                              </td>
                            </tr>
                            {teacherTableValue.breakTime && (
                              <tr>
                                <td
                                  colSpan={7}
                                  className="schedule-table-break-section"
                                >
                                  <div className="schedule-table-break-section-data-main">
                                    <div className="schedule-table-break-section-dotted" />
                                    <p className="schedule-table-break-section-title">
                                      Break 09:15 to 10:00
                                    </p>
                                    <div className="schedule-table-break-section-dotted" />
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        );
                      }
                    )}
                  </table>
                </div>
              </Grid>
              <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
                <div class="schedule-week-list-header">
                  No. of Each Lecture Each Week
                </div>
                <table className="schedule-week-list-table">
                  <tr>
                    <td className="schedule-week-list-table-data">Week 1</td>
                    <td className="schedule-week-list-table-data">15</td>
                  </tr>
                  <tr>
                    <td className="schedule-week-list-table-data">Week 2</td>
                    <td className="schedule-week-list-table-data">15</td>
                  </tr>
                  <tr>
                    <td className="schedule-week-list-table-data">Week 3</td>
                    <td className="schedule-week-list-table-data">15</td>
                  </tr>
                  <tr>
                    <td className="schedule-week-list-table-data">Week 4</td>
                    <td className="schedule-week-list-table-data">15</td>
                  </tr>
                </table>
                <div class="schedule-week-list-header">
                  No. of Lecture In January
                </div>
                <table className="schedule-week-list-table">
                  <tr>
                    <td className="schedule-week-list-table-data">60</td>
                  </tr>
                </table>
                <div class="schedule-week-list-header">
                  No. of Each Lecture Each Week
                </div>
                <table className="schedule-week-list-table">
                  <tr>
                    <td className="schedule-week-list-table-data">Value</td>
                    <td className="schedule-week-list-table-data">200</td>
                  </tr>
                  <tr>
                    <td className="schedule-week-list-table-data">Currency</td>
                    <td className="schedule-week-list-table-data">INR</td>
                  </tr>
                </table>
              </Grid>
            </Grid>
          </Box>
        </div>
      )}

      <Model
        modelTitle="Edit Schedule"
        onClose={() => setEditModel(false)}
        open={editModel}
        buttonTitle="Submit"
        buttonHandler={() => setEditModel(false)}
      >
        <div className="form-container">
          <Box sx={{ flexGrow: 1 }}>
            <Grid container spacing={2}>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Teachers Name</p>
                  <input
                    type="text"
                    className="input"
                    placeholder="Teachers Name"
                  />
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                <div>
                  <p className="input-heading">Classs</p>
                  <input type="text" className="input" placeholder="Classs" />
                </div>
              </Grid>
              <Grid item xl={6} lg={6} md={6} sm={6} xs={6}>
                <div>
                  <p className="input-heading">Division</p>
                  <input type="text" className="input" placeholder="Division" />
                </div>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">Reason</p>
                  <input
                    type="text"
                    className="input"
                    placeholder="Enter Reason"
                  />
                </div>
              </Grid>
              <Grid item xl={12} lg={12} md={12} sm={12} xs={12}>
                <div>
                  <p className="input-heading">
                    covered by another teacher name{" "}
                  </p>
                  <input
                    type="text"
                    className="input"
                    placeholder="teacher name"
                  />
                </div>
              </Grid>
            </Grid>
          </Box>
        </div>
      </Model>
    </div>
  );
};
export default Schedule;
